import { MenuItem } from '@plasma/ui.application.app-provider';

const companyId= sessionStorage.getItem('companyID');
const superUserRole= sessionStorage.getItem('superUserRole');

export const menuItems: MenuItem[] = (companyId?.length && superUserRole?.length) ? ([
  {
    label: 'Home',
    icon: 'Home',
    path: 'home-screen',
  },

  {
    label: 'Production Line',
    icon: 'warehouse',
    path: '/company-home',
  },

  {
    label: 'Consumable Estimation',
    icon: 'tips_and_updates',
    path: 'consumable-quantity-estimation',
  },
  {
    label: 'Production Plan',
    icon: 'balance',
    path: 'production-figure',
  },

  {
    label: 'Consumable Lifetime & Cycle',
    icon: 'update',
    path: 'consumable-lifetime-cycle',
  },

  {
    label: 'PLANT SETUP',
    icon: 'settings',
    path: '/master-data',
    children: [
      {
        label: 'Production Line Editor',
        icon: 'edit_note',
        path: 'plant-layout-editor',
      },

      {
        label: 'Upload Plant Configuration',
        icon: 'file_upload',
        path: 'upload-excel',
      },

      {
        label: 'Profile Detail',
        icon: 'info_outline',
        path: 'product-detail',
      },

      {
        label: 'Profile Families',
        icon: 'category',
        path: 'product-families',
      },

      {
        label: 'Area Editor',
        icon: 'map',
        path: 'area-master',
      },

      {
        label: 'Zone Editor',
        icon: 'place',
        path: 'zone-master',
      },

      {
        label: 'Equipment Editor',
        icon: 'handyman',
        path: 'equipment-master',
      },

      {
        label: 'Consumable Editor',
        icon: 'miscellaneous_services',
        path: 'consumables-master',
      },

      {
        label: 'Material Editor',
        icon: 'shopping_cart',
        path: 'raw-material-master',
      },

      {
        label: 'Roll Pass Design',
        icon: 'webhook',
        path: 'role-base-design',
      },

      {
        label: 'Item Document Finder',
        icon: 'find_in_page',
        path: 'item-document-finder',
      },
      {
        label: 'Consumable Overview & Utilization',
        icon: 'satellite',
        path: 'consumable-overview',
      },
      {
        label: 'Shopping Cart',
        icon: 'shopping_cart',
        path: 'shopping-cart',
      },
      {
        label: 'Current RFQ Status',
        icon: 'troubleshoot',
        path: 'current-rfq-status',
      },

      {
        label: 'All rfq',
        icon: 'troubleshoot',
        path: 'all-rfq',
      },

    ],
  },

  {
    label: 'USER SETUP',
    icon: 'person',
    path: '/user-master-data',
    children: [
      {
        label: 'All Companies',
        icon: 'business',
        path: 'all-companies',
      },

      {
        label: 'Associated Personnel',
        icon: 'supervisor_account',
        path: 'associated-personnel',
      },
      {
        label: 'All Personnel',
        icon: 'person_add',
        path: 'all-personnel',
      },

      {
        label: 'All Users',
        icon: 'groups_3',
        path: '/users-page',
      },

      {
        label: 'Create New Project',
        icon: 'add',
        path: 'create-new-project',
      },
    ],
  },
]) : [];
